"use client"

import { useState, useEffect, useRef } from "react"
import "./CareerHow.css"
import { FaCode, FaUsers, FaChartLine, FaCogs } from "react-icons/fa" // Replace or add icons as needed

const tabs = [
  { key: "engineering", title: "WE'VE GOT YOU", icon:<img src="/icon9.svg" alt="Engineering" /> },
  { key: "team", title: "SQUAD GOALS", icon: <img src="/squad.svg" alt="Engineering" />  },
  { key: "growth", title: "OWN IT", icon: <img src="/own.svg" alt="Engineering" /> },
  { key: "operations", title: "LEVEL-UP", icon: <img src="/level.svg" alt="Engineering" />  },
  { key: "career", title: "WORK.PARTY.REPEAT", icon: <img src="/work.svg" alt="Engineering" />  },
  
]

const tabContents = {
  engineering: [
    {
      title: "WE'VE GOT YOU",
      description: "From the moment you join Imaginary Cloud, we want to ensure you have all the tools you need to succeed. So during the onboarding process, we want you to get familiar with our tech stack and processes. We also pair each Imaginaree with a People Experience Partner who provides professional and personal guidance along with helping you define your future career goals."
    },
    
  ],
  team: [
    {
      title: "SQUAD GOALS",
      description: "Once you're up to speed, you'll be part of a like-minded people squad. The team can assist you in resolving daily concerns, prioritising activities, and tracking project progress. Since this is an Agile team, we'll develop a strategy to solve issues collectively and ensure everyone gets the help they need to stay productive!"
    },
    
  ],
  growth: [
    {
      title: "OWN IT",
      description: "We’re dedicated to empowering people to bring their A-game. Responsibility is a small step for our work but a giant leap for overall success. It’s an essential piece that leads to awe-inspiring accomplishments. Here, opportunities arise each day to demonstrate your potential further and leave an incredible impact."
    },
    
  ],
  operations: [
    {
      title: "LEVEL-UP",
      description: "Our Management and People Experience Partners evaluate our performance biannually to maximise our potential. During this time we do a self-assessment of the last 6 months and we receive feedback about our progress. So we'll work together to make sure we succeed every review period and aim for the sky!"
    },
   
  ],
   career :[
    {
      title: "WORK.PARTY.REPEAT",
      description: "Imaginarees are always ready to mingle and have a good time. We know that we work to live and that making the most of every moment is important. Every month, we look for new experiences, learnings, and great people to share them with. And twice a year, we get together and explore new places to express our gratitude and celebrate the amazing people we have here on our team!"
    },
   
  ],
  
}

const CareerWorking = () => {
  const [activeTab, setActiveTab] = useState("engineering")
  const progressBarRef = useRef(null)

  useEffect(() => {
    const total = tabs.length
    const index = tabs.findIndex(tab => tab.key === activeTab)
    const progress = ((index + 1) / total) * 100
    if (progressBarRef.current) {
      progressBarRef.current.style.width = `${progress}%`
    }
  }, [activeTab])

  return (
    <section className="career-working-section7193">
      <div className="container">
     <div className="career-working-title7193"><h2 >HOW WE <br></br> <span className="blue-text">WORK</span></h2></div>
       
      <div className="career-card7193">
        {/* Tab Bar */}
        <div className="tab1-bar7193">
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`tab1-btn7193 ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <div className="tab1-icon7193">{tab.icon}</div>
              <div className="tab1-title7193">{tab.title}</div>
            </button>
          ))}
          <div className="tab1-progress7193">
            <div className="tab-progress-bar7193" ref={progressBarRef}></div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tab1-content7193">
          {tabContents[activeTab].map((item, index) => (
            <div key={index} className="content-card7193">
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  )
}

export default CareerWorking
